import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const ShareIcon = ({ className, color = Color.Black }: NewIconProps) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M18 9L12 3L6 9L7.37258 10.3726L11.0294 6.71573V15H12.9706V6.71573L16.6274 10.3726L18 9Z" fill={color} />
    <path d="M4 19V14H6V19H18V14H20V19C20 20.1 19.1 21 18 21H6C4.9 21 4 20.1 4 19Z" fill={color} />
  </svg>
);
